import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useRecentStore, useSearchStore } from "../..";
import RecentSearchItem from "./RecentSearchItem";
import RecentViewItem from "./RecentViewItem";
import styles from './SearchPanel.module.css';

function RecentItems({ setItemCount }: IRecentItemsProps) {
    const recentStore = useRecentStore();
    const searchStore = useSearchStore();

    useEffect(() => {
        setItemCount(recentStore.recentSearches.length + recentStore.recentItems.length);
    }, [setItemCount, recentStore.recentSearches, recentStore.recentItems]);

    return (
        <>
            <div className={styles.header}>
                Recent Searches
            </div>
            {!recentStore.recentSearches.length && (
                <div className={styles.emptyLabel}>
                    Your recent searches will be displayed here.
                </div>
            )}
            {recentStore.recentSearches.map((item, index) => (
                <RecentSearchItem
                    key={`${item.query}-${item.type}`}
                    query={item.query}
                    type={item.type}
                    className={[styles.lineItem, searchStore.selectedItemIndex === index ? styles.itemHover : ""].join(" ")}
                    index={index}
                />
            ))}
            <div className={styles.header}>
                Recently Viewed
            </div>
            {!recentStore.recentItems.length && (
                <div className={styles.emptyLabel}>
                    Your recently viewed items will be displayed here.
                </div>
            )}
            {recentStore.recentItems.map((item, index) => (
                <RecentViewItem
                    key={`${item.id}-${item.type}`}
                    id={item.id}
                    type={item.type}
                    className={[styles.blockItem, searchStore.selectedItemIndex === recentStore.recentSearches.length + index ? styles.itemHover : ""].join(" ")}
                    index={recentStore.recentSearches.length + index}
                />
            ))}
        </>
    );
}

export default observer(RecentItems);

interface IRecentItemsProps {
    setItemCount: (count: number) => void;
}